/*eslint-disable*/export const messages=JSON.parse("{\"modal.aria.back\":[\"Back\"],\"modal.aria.close\":[\"Close\"]}");